module.exports = __webpack_public_path__ + "202408221624/img/img_blank_118_86@2x.f8767d31.png";